export function readStickyTopPx(): number {
  const raw = getComputedStyle(document.documentElement)
    .getPropertyValue("--explore-sticky-top")
    .trim();
  const parsed = Number.parseFloat(raw);
  if (Number.isFinite(parsed)) {
    return parsed;
  }

  const sentinel = document.createElement("div");
  sentinel.style.position = "absolute";
  sentinel.style.top = "-9999px";
  sentinel.style.height = "var(--explore-sticky-top)";
  document.body.append(sentinel);
  const measured = sentinel.offsetHeight;
  sentinel.remove();
  return measured;
}
